import { AI_GATES } from "../content";
import { AiSectionHead } from "./AiSection";

/** 四道关口卡片（GATE 01-04），每卡含验收点。对应设计稿第 5 节。 */
export default function AiGates() {
  return (
    <section aria-labelledby="ai-gates-h" className="py-14 lg:py-20">
      <div className="rounded-3xl bg-[#f8fafc] border border-gray-100 px-6 lg:px-10 py-12 lg:py-16">
        <AiSectionHead eyebrow={AI_GATES.eyebrow} title={AI_GATES.title} sub={AI_GATES.sub} />
        <div className="grid gap-4 lg:gap-6 sm:grid-cols-2 xl:grid-cols-4">
          {AI_GATES.cards.map((g) => (
            <article
              key={g.no}
              className="relative p-6 rounded-2xl bg-white border border-gray-200 border-t-4 border-t-[#1a56db] transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(13,31,60,0.12)] flex flex-col"
            >
              <span className="font-mono text-xs font-bold text-[#9ca3af] tracking-[0.1em]">{g.no}</span>
              <h3 className="text-lg font-bold text-[#0d1f3c] mt-2 mb-1">{g.name}</h3>
              <p className="text-xs font-bold text-[#1a56db] mb-4">{g.phase}</p>
              <p className="m-0 mb-5 text-sm text-[#475569] leading-relaxed">{g.desc}</p>
              <div className="mt-auto text-xs text-[#334155] bg-[#f8fafc] border border-gray-200 border-l-[3px] border-l-[#059669] rounded-md p-3 lg:p-4 leading-relaxed">
                <b className="text-[#059669]">验收点：</b>
                {g.verify}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
